import { simulationFailure } from '../../utils/simulationFailure';
import {
  SIMULATION_FAILED_TEAM_ALERTED,
  SIMULATION_FAILED_TITLE,
} from '../simulationResults/failureCopy';

export type ChatSimulationOutcome = 'running' | 'completed' | 'failed';

export interface ChatSimulationDetail {
  status?: unknown;
  simulation_response?: unknown;
}

const FAILED_STATUSES: unknown[] = ['failed', 'error'];
const EMPTY_RESPONSE = '{}';

export const SIMULATION_OUTCOME_MESSAGES: Record<
  Exclude<ChatSimulationOutcome, 'running'>,
  string
> = {
  completed: 'Your report is ready! Click **View Report** in the top right to open it.',
  failed: `${SIMULATION_FAILED_TITLE}. ${SIMULATION_FAILED_TEAM_ALERTED}`,
};

/** Where a simulation the chat dispatched stands, from `GET /bluepill-chat/simulations/{id}`. */
export function chatSimulationOutcome(
  detail: ChatSimulationDetail | null | undefined,
): ChatSimulationOutcome {
  if (!detail) return 'running';
  const response = detail.simulation_response;
  if (FAILED_STATUSES.includes(detail.status) || simulationFailure(response)) return 'failed';
  return !!response && response !== EMPTY_RESPONSE ? 'completed' : 'running';
}
